/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".record-box[_ngcontent-%COMP%]{border-radius:4px;border:1px solid #cecece;padding:10px;margin-top:30px}.ok-btn[_ngcontent-%COMP%]{height:36px;border:none;border-radius:3px;background-color:#467fcf;color:#fff;width:96px}\n/*# sourceMappingURL=revoke-failed-order.component.css.map*/"];
export { styles as styles };
